import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0eae209d"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=0eae209d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eae209d')) {
      api.createRecord('0eae209d', component.options)
    } else {
      api.reload('0eae209d', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=0eae209d", function () {
      api.rerender('0eae209d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/iframe/main.vue"
export default component.exports